import { AdvisorViewTarget, openAdvisorView } from "./openAdvisorView";

type AdvisorViewLinkProps = {
    target: AdvisorViewTarget | null;
    title?: string;
    children: React.ReactNode;
};

const AdvisorViewLink = ({ target, title, children }: AdvisorViewLinkProps) => {
    if (!target) return <>{children}</>;

    return (
        <button
            type="button"
            className="advisor-view-link"
            title={title}
            onClick={() => openAdvisorView(target)}
        >
            {children}
        </button>
    );
};

export default AdvisorViewLink;
